import React from 'react';
import { Button } from 'kepler';

export default class PartnerApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorType: this.props.errorType
    };
  }
  render() {
    return (
      <div>
        <div className="erroPage">
          <p class="textcenter">
            <img src="https://www.paypalobjects.com/webstatic/ppgf/info.png" />
          </p>
          {(() => {
            switch (this.state.errorType) {
              case 'session':
                return <h3>Something went wrong. Please try again!</h3>;
              case 'serviceError':
                return (
                  <h3>
                    Please contact us care@paypalgivingfund.org for further
                    assistance.
                  </h3>
                );
              default:
                return null;
            }
          })()}
          <Button
            href="/givingfund/partner"
            className="newSearchBtn"
            type="primary"
          >
            Start new Search
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./partner/components/partnerError.js